import React from 'react';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

class EditorDraf extends React.Component {
  constructor(props, context) {
    super(props, context);
    const html = this.props.value;
    const contentBlock = htmlToDraft(html);
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
      const editorState = EditorState.createWithContent(contentState);
      this.state = {
        editorState
      };
    } else {
      this.state = {
        editorState: EditorState.createEmpty()
      }
    }
  }

  onEditorStateChange(editorState) {
    this.setState({
      editorState
    }, ()=> {
      let data = {
        target: {
          value: draftToHtml(convertToRaw(editorState.getCurrentContent()))
        }
      }
      this.props.onChange(data);
    });
  };

  render() {
    const { editorState } = this.state;
    return (
      <section className="editor-draf">
        <Editor
          editorState={editorState}
          wrapperClassName="demo-wrapper"
          editorClassName="demo-editor"
          onEditorStateChange={this.onEditorStateChange.bind(this)}
        />
      </section>
    );
  }
}

EditorDraf.defaultProps = {
  value: '',
  onChange: function() {
    console.log('Need to assign onChange method');
  }
}

export default EditorDraf;


// WEBPACK FOOTER //
// ./components/partials/editor/EditorDraf.jsx